<template>
  <header class="header-global">
    <base-nav class="navbar-main" transparent type="" effect="light" expand>
      <router-link slot="brand" class="navbar-brand mr-lg-4" to="/">
        <img src="../assets/img/ptwist_logo_50_50.png"> <span class="ml-1">PlasticTwist Crowdsourcing</span>
      </router-link>
      <div class="row" slot="content-header" slot-scope="{closeMenu}">
        <div class="col-10 collapse-brand">
          <router-link to="/" @click="closeMenu">
            <img class="nav-mobile-logo" src="../assets/img/ptwist_logo_50_50.png">
            <span class="nav-mobile-logo-text"> PlasticTwist Crowdsourcing API </span>
          </router-link>
        </div>
        <div class="col-2 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <ul class="navbar-nav navbar-nav-hover align-items-center w-100">
        <!--<router-link to="/locations" class="nav-link">Locations</router-link>-->
        <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
          <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">

            <span class="nav-link-inner--text">Visualizations
              <font-awesome-icon class="ml-1" :icon="{ prefix: 'fas', iconName: 'chevron-down' }"/> </span>
          </a>
          <div class="dropdown-menu-inner">
            <router-link to="/visualizations/wordclouds"
                         v-on:click.native="emitNavClose"
                         class="media d-flex align-items-center">
              <div class="icon icon-shape bg-gradient-success rounded-circle text-white">
                <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'comments' }"/>
              </div>
              <div class="media-body ml-3">
                <h6 class="heading text-success mb-md-1">Wordclouds</h6>
                <p class="description d-none d-md-inline-block mb-0">View wordcloud and hashcloud visualizations based
                  on tweets text data.</p>
              </div>
            </router-link>
          </div>
          <div class="dropdown-menu-inner">
            <router-link to="/visualizations/locations"
                         v-on:click.native="emitNavClose"
                         class="media d-flex align-items-center">
              <div class="icon icon-shape bg-gradient-warning rounded-circle text-white">
                <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'map-marked-alt' }"/>
              </div>
              <div class="media-body ml-3">
                <h6 class="heading text-warning mb-md-1">Locations</h6>
                <p class="description d-none d-md-inline-block mb-0">Check out the locations of tweets regarding plastic
                  pollution worldwide organized as clusters or heat.</p>
              </div>
            </router-link>
          </div>
          <div class="dropdown-menu-inner">
            <router-link to="/visualizations/topic-modeling?collection=plastic_pollution&topic=1"
                         v-on:click.native="emitNavClose"
                         class="media d-flex align-items-center">
              <div class="icon icon-shape bg-gradient-orange rounded-circle text-white">
                <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'sitemap' }"/>
              </div>
              <div class="media-body ml-3">
                <h5 class="heading text-orange mb-md-1">Topic Modeling</h5>
                <p class="description d-none d-md-inline-block mb-0">Discover the topics that were detected
                  on our tweets.</p>
              </div>
            </router-link>
          </div>
        </base-dropdown>
        <!--<router-link to="/wordclouds" class="nav-link">Wordclouds</router-link>-->
        <router-link v-on:click.native="emitNavClose" to="/repositories" class="nav-link">Repositories</router-link>
        <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
          <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">

            <span class="nav-link-inner--text">Influential Content<font-awesome-icon class="ml-1"
                                                                                     :icon="{ prefix: 'fas', iconName: 'chevron-down' }"/> </span>
          </a>
          <div class="dropdown-menu-inner">
            <router-link to="/prevalent-data/top-posts"
                         v-on:click.native="emitNavClose"
                         class="media d-flex align-items-center">
              <div class="icon icon-shape bg-gradient-twitter rounded-circle text-white">
                <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'chart-line' }"/>
              </div>
              <div class="media-body ml-3">
                <h6 class="heading text-twitter mb-md-1">Top posts</h6>
                <p class="description d-none d-md-inline-block mb-0">Check out the posts regarding
                  plastic pollution based on several parameters</p>
              </div>
            </router-link>
            <router-link to="/prevalent-data/top-urls"
                         v-on:click.native="emitNavClose"
                         class="media d-flex align-items-center">
              <div class="icon icon-shape bg-gradient-primary rounded-circle text-white">
                <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'link' }"/>
              </div>
              <div class="media-body ml-3">
                <h5 class="heading text-primary mb-md-1">Top URLS</h5>
                <p class="description d-none d-md-inline-block mb-0">Get the most popular tweets' links
                  pointing to new or other resources regarding plastic reusability</p>
              </div>
            </router-link>
            <router-link to="/prevalent-data/influencers"
                         v-on:click.native="emitNavClose"
                         class="media d-flex align-items-center">
              <div class="icon icon-shape bg-gradient-danger rounded-circle text-white">
                <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'users' }"/>
              </div>
              <div class="media-body ml-3">
                <h5 class="heading text-danger mb-md-1">Influencers</h5>
                <p class="description d-none d-md-inline-block mb-0">Check on the most influential Twitter users
                  that were extracted from our data.</p>
              </div>
            </router-link>
          </div>
        </base-dropdown>
        <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
          <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">

            <span class="nav-link-inner--text">Activities
              <font-awesome-icon class="ml-1" :icon="{ prefix: 'fas', iconName: 'chevron-down' }"/> </span>
          </a>
          <div class="dropdown-menu-inner">
            <router-link to="/ideas/swiss-pilot"
                         v-on:click.native="emitNavClose"
                         class="media d-flex align-items-center">
              <div class="icon icon-shape bg-gradient-switzerland rounded-circle text-white">
                <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'lightbulb' }"/>
              </div>
              <div class="media-body ml-3">
                <h6 class="heading text-yellow mb-md-1">Swiss Pilot Ideas</h6>
                <!--                <p class="description d-none d-md-inline-block mb-0">Participatory Lab @ Youth Hostel, Athens</p>-->
              </div>
            </router-link>
            <router-link to="/ideas/greek-pilot"
                         v-on:click.native="emitNavClose"
                         class="media d-flex align-items-center">
              <div class="icon icon-shape bg-gradient-greece rounded-circle text-white">
                <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'lightbulb' }"/>
              </div>
              <div class="media-body ml-3">
                <h6 class="heading text-yellow mb-md-1">Greek Pilot Ideas</h6>
                <!--                <p class="description d-none d-md-inline-block mb-0">Participatory Lab @ Youth Hostel, Athens</p>-->
              </div>
            </router-link>
            <router-link to="/ideas/dutch-pilot"
                         v-on:click.native="emitNavClose"
                         class="media d-flex align-items-center">
              <div class="icon icon-shape bg-gradient-netherlands rounded-circle text-white">
                <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'lightbulb' }"/>
              </div>
              <div class="media-body ml-3">
                <h6 class="heading text-yellow mb-md-1">Dutch Pilot Ideas</h6>
                <!--                <p class="description d-none d-md-inline-block mb-0">Participatory Lab @ Youth Hostel, Athens</p>-->
              </div>
            </router-link>
            <div class="dropdown-divider"></div>
            <router-link :key="index" v-for="(event, index) in events" :to="'/events/' + event.href"
                         v-on:click.native="emitNavClose"

                         class="media d-flex align-items-center">
              <div class="icon icon-shape bg-gradient-success rounded-circle text-white">
                <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'calendar-alt' }"/>
              </div>
              <div class="media-body ml-3">
                <h6 class="heading text-yellow mb-md-1"> {{ event.name }} | {{event.date}} </h6>
                <p class="description d-none d-md-inline-block mb-0">{{ event.subtext }}</p>
              </div>
            </router-link>
          </div>
        </base-dropdown>
        <li class="d-none d-sm-block ml-auto">

        </li>

        <a target="_blank" href="https://ptwist.csd.auth.gr:20443/documentation">
          <base-button
            tag="li"
            target="_blank"
            class="mb-3 mb-sm-0 text-white nav-item ml-auto"
            type="blue"
            :icon="{ prefix: 'fas', iconName: 'book'}">
            API Docs

          </base-button>
        </a>
        <a target="_blank" href="https://ptwist.csd.auth.gr/home">
          <base-button
            tag="li"
            target="_blank"
            class="text-white ml-auto"
            type="default"
            :icon="{ prefix: 'fas', iconName: 'cloud'}">
            Home
          </base-button>
        </a>

      </ul>
    </base-nav>
  </header>
</template>
<script>
import { Bus } from '../bus'
import BaseNav from '@/components/BaseNav'
import BaseDropdown from '@/components/BaseDropdown'
import CloseButton from '@/components/CloseButton'

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  },
  methods: {
    emitNavClose () {
      Bus.$emit('menu-item-clicked')
    }
  },
  data: () => ({
    events: [
      {
        name: 'PLASTICtiwst ISTANBUL EVENT',
        date: '12.06.2019',
        subtext: 'Innovation BootCamp @ TAK Design Atelier Kadikoy, Istanbul',
        href: 'plastictwist-istanbul'
      },
      {
        name: 'PLASTICtwist THESSALONIKI EVENT',
        date: '07.06.2019',
        subtext: 'ScienceCafe & Innovation BootCamp @ Convention Center "I. Vellidis", Thessaloniki',
        href: 'plastictwist-thessaloniki'
      },
      {
        name: 'PLASTICtwist ATHENS EVENT',
        date: '11.04.2019',
        subtext: 'Participatory Lab @ Youth Hostel, Athens',
        href: 'plastictwist-athens'
      },
      {
        name: 'PLASTICtwist CHALLENGE',
        date: '18.02.2019',
        subtext: 'Workshops @ Fablab, Luzern',
        href: 'plastictwist-challenge'
      }

    ]
  })
}
</script>
<style scoped>
  .nav-mobile-logo {
    width: 30px;
    height: 30px !important;
  }

  .nav-mobile-logo-text {
    font-size: 13px;
  }

  .heading {
    text-transform: none;
    font-size: 0.90rem
  }
</style>
